<template></template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        navigationWithNumber: {
          name: "navigationWithNumber",
          defaultValue: "",
          labelDesc: "navigation-with-number",
          callback: function() {
            vm.resources.navigationWithNumber.defaultValue = this.value;
            vm.element.internal_config.navigationWithNumber = this.value;
          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function () {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

          },
        },
        galleryTheme: {
          name: 'galleryTheme',
          defaultValue: 'matriz',
          defaultOptions: [
            {
              name: 'matriz',
              value: 'matriz'
            },
            {
              name: 'alternating',
              value: 'alternating'
            },
            {
              name: 'tiles',
              value: 'tiles'
            },
            {
              name: 'mixed',
              value: 'mixed'
            },
            {
              name: 'one-main',
              value: 'one-main'
            }
          ],
          labelDesc: 'gallery-theme',
          callback: function() {
            vm.resources.galleryTheme.defaultValue = this.value;
            vm.element.internal_config.theme = this.value;
          }
        },
        navigationBackground: {
          name: "navigationBackground",
          defaultValue: "#b3b3b3",
          gradient: true,
          labelDesc: "resource-bg-color",
          callback: function() {
            vm.resources.navigationBackground.defaultValue = this.colorValue;
            vm.element.internal_config.navigationBackground = this.colorValue;
          }
        },
        navigationHover: {
          name: "navigationHover",
          defaultValue: "#6C6C6F",
          gradient: true,
          labelDesc: "resource-bg-color-hover",
          callback: function() {
            vm.resources.navigationHover.defaultValue = this.colorValue;
            vm.element.internal_config.navigationHover = this.colorValue;
          }
        },
        navigationActive: {
          name: "navigationActive",
          defaultValue: "41A9FF",
          gradient: true,
          labelDesc: "bg-color-active",
          callback: function() {
            vm.resources.navigationActive.defaultValue = this.colorValue;
            vm.element.internal_config.navigationActive = this.colorValue;
          }
        },
        columns: {
          name: "columns",
          defaultValue: 3,
          min: 1,
          max: 10,
          labelDesc: "columns",
          callback: function() {
            vm.resources.columns.defaultValue = this.value;
            vm.element.internal_config.columns = this.value;
          }
        },
        imagesPerPage: {
          name: "imagesPerPage",
          defaultValue: 3,
          min: 1,
          max: 10,
          labelDesc: "images-per-page",
          callback: function() {
            vm.resources.imagesPerPage.defaultValue = this.value;
            vm.element.internal_config.imagesPerPage = this.value;

            vm.element.build();
          }
        },
        verticalMargin: {
          name: "verticalMargin",
          defaultValue: 5,
          min: 0,
          max: 50,
          labelDesc: "vertical-margin",
          callback: function() {
            vm.resources.verticalMargin.defaultValue = this.value;
            vm.element.internal_config.verticalMargin = this.value;
          }
        },
        horizontalMargin: {
          name: "horizontalMargin",
          defaultValue: 5,
          min: 0,
          max: 50,
          labelDesc: "horizontal-margin",
          callback: function() {
            vm.resources.horizontalMargin.defaultValue = this.value;
            vm.element.internal_config.horizontalMargin = this.value;
          }
        },
        zIndex: {
          name: "zIndex",
          defaultValue: "",
          labelDesc: "zIndex",
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: "width",
          defaultValue: "150",
          min: "1",
          max: "1000",
          labelDesc: "width",
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + "px";
          }
        },
        height: {
          name: "height",
          defaultValue: "300",
          min: "1",
          max: "1000",
          labelDesc: "height",
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.height = this.value + "px";
          }
        },
        minHeight: {
          name: "minHeight",
          defaultValue: "100",
          min: "0",
          max: "600",
          labelDesc: "minHeight",
          callback: function() {
            vm.resources.minHeight.defaultValue = this.value;
            vm.element.internal_config.minHeight = this.value + "px";
          }
        },
        border: {
          name: "border",
          defaultValue: "1px solid black",
          min: "0",
          max: "50",
          labelDesc: "border",
          callback: function() {
            let value = this.value + "px " + this.value2 + " " + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.border = value;
          }
        },
        opacity: {
          name: "opacity",
          defaultValue: "100",
          min: "0",
          max: "100",
          labelDesc: "opacity",
          callback: function() {
            vm.resources.opacity.defaultValue = this.value;
            vm.element.internal_config.opacity = this.value / 100;
          }
        },
        // boxShadow: {
        //   name: "boxShadow",
        //   defaultValue: "0 0 0 0 black initial",
        //   min: "0",
        //   max: "50",
        //   labelDesc: "boxShadow",
        //   inset: false,
        //   callback: function() {
        //     let value =
        //       this.h +
        //       "px " +
        //       this.v +
        //       "px " +
        //       this.b +
        //       "px " +
        //       this.s +
        //       "px " +
        //       this.colorValue +
        //       " " +
        //       (this.i === true ? "inset" : "");
        //
        //     vm.resources.boxShadow.defaultValue = value;
        //     vm.element.internal_config.boxShadow = value;
        //   }
        // },
        borderRadius: {
          name: "borderRadius",
          defaultValue: "0 0 0 0",
          min: "0",
          max: "360",
          labelDesc: "borderRadius",
          callback: function() {
            let value =
              this.v1 +
              "px " +
              this.v2 +
              "px " +
              this.v3 +
              "px " +
              this.v4 +
              "px";

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.borderRadius = value;
          }
        },
        padding: {
          name: "padding",
          defaultLeft: "15",
          defaultTop: "15",
          defaultRight: "15",
          defaultBottom: "15",
          min: "0",
          max: "100",
          labelDesc: "padding",
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + "px";

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + "px";

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + "px";

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + "px";
          }
        },
        // margin: {
        //   name: "margin",
        //   defaultLeft: "15",
        //   defaultRight: "15",
        //   min: "0",
        //   max: "50",
        //   labelDesc: "margin",
        //   callback: function() {
        //     vm.resources.margin.defaultLeft = this.l;
        //     vm.element.internal_config.marginLeft = this.l + "px";
        //
        //     vm.resources.margin.defaultRight = this.r;
        //     vm.element.internal_config.marginRight = this.r + "px";
        //   }
        // }
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;

      this.resources.navigationWithNumber.defaultValue =
        data.internal_config.navigationWithNumber;

      this.resources.navigationBackground.defaultValue =
        data.internal_config.navigationBackground;

      this.resources.navigationHover.defaultValue =
        data.internal_config.navigationHover;

      this.resources.navigationActive.defaultValue =
        data.internal_config.navigationActive;

      this.resources.columns.defaultValue = parseInt(
        data.internal_config.columns
      );
      this.resources.imagesPerPage.defaultValue = parseInt(
        data.internal_config.imagesPerPage
      );
      this.resources.verticalMargin.defaultValue = parseInt(
        data.internal_config.verticalMargin
      );
      this.resources.horizontalMargin.defaultValue = parseInt(
        data.internal_config.horizontalMargin
      );

      this.resources.width.defaultValue = parseInt(data.internal_config.width);
      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);
      this.resources.height.defaultValue = parseInt(
        data.internal_config.height
      );
      this.resources.minHeight.defaultValue = parseInt(
        data.internal_config.minHeight
      );

      this.resources.opacity.defaultValue = data.internal_config.opacity * 100;
      this.resources.galleryTheme.defaultValue = data.internal_config.theme;

      // this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;
      this.resources.borderRadius.defaultValue =
        data.internal_config.borderRadius;
      this.resources.border.defaultValue = data.internal_config.border;

      this.resources.padding.defaultLeft = parseInt(
        data.internal_config.paddingLeft
      );
      this.resources.padding.defaultTop = parseInt(
        data.internal_config.paddingTop
      );
      this.resources.padding.defaultRight = parseInt(
        data.internal_config.paddingRight
      );
      this.resources.padding.defaultBottom = parseInt(
        data.internal_config.paddingBottom
      );

      // this.resources.margin.defaultLeft = parseInt(
      //   data.internal_config.marginLeft
      // );
      // this.resources.margin.defaultRight = parseInt(
      //   data.internal_config.marginRight
      // );
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/ImageGallery/Resources.vue